module.exports = __webpack_public_path__ + "static/media/river2.baac31f7.png";